import { resolve } from "inversify-react";
import { parse } from "query-string";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import NavNotifier from "../../core/ui/nav-notifier";
import { actions } from "../../actions/main.actions";
import Container from "../../core/ui/container";
import RaritySelect from "../../core/ui/data-component/rarity-select";
import GalleryHeader from "../../core/ui/gallery-header";
import Grid, { Col } from "../../core/ui/grid";
import LateInput from "../../core/ui/late-input";
import ArtsDataService from "./arts.data.service";
import GalleryGrid from "./gallery-grid";
import { IApplicationState } from "../../typings";

export interface GalleryRequest {
    pageSize: number;
    pageNumber: number;
    filter: any;
}
export interface ArtsPageProps extends RouteComponentProps<any> {
    urlPreffix: string;
}

export interface ArtsPageState {
    pageSize?: number;
    pageNumber?: number;
    rarityFilter?: number;
    text?: string;
}

export const PageSize = 11;

export class ArtsPage extends React.Component<ArtsPageProps & typeof actions, ArtsPageState> {
    @resolve(ArtsDataService)
    public dataService: ArtsDataService;

    constructor(props) {
        super(props);
        this.state = {};
    }

    public componentWillReceiveProps(nextProps: ArtsPageProps) {
        if (nextProps.history !== this.props.history) {
            this.setPages(nextProps);
        }
    }

    public setPages = (props) => {
        let params: GalleryRequest = parse(props.history.location.search);
        if (params.pageSize && params.pageNumber) {
            this.setState({
                pageSize: params.pageSize,
                pageNumber: params.pageNumber,
            });
        } else {
            this.setState({
                pageSize: PageSize,
                pageNumber: 1,
            });
        }
    };

    public componentDidMount() {
        this.props.changeLocation("arts");
        this.setPages(this.props);
    }

    public render() {
        return (
            <React.Fragment>
                <NavNotifier idk="light">
                    <Container className="no-padding" light={true}>
                        <Grid centered={true}>
                            <Col size={80}>
                                <GalleryHeader
                                    tokenCountRetriever={() =>
                                        new Promise<number>((resolve, reject) => {
                                            this.dataService.getGalleryItems(1, 1).then((result) => {
                                                resolve(result.results[0].count);
                                            });
                                        })
                                    }
                                />
                                <div className="art-header">
                                    <LateInput
                                        placeholder="Type to filter by title"
                                        onChange={(e) => this.setState({ text: e })}
                                        delay={20}
                                    />
                                    <div className="section-name-container"> </div>
                                    <div className="list-filter">
                                        <h4 className="filter-name">FILTER</h4>
                                        <RaritySelect
                                            onChange={(e) => {
                                                this.setState({ rarityFilter: e.id });
                                            }}
                                            type="fill"
                                            extraData={[
                                                {
                                                    id: undefined,
                                                    display_name: "All",
                                                },
                                            ]}
                                            placeholder="Filter by category"
                                        />
                                    </div>
                                </div>
                                {this.state.pageNumber && (
                                    <GalleryGrid
                                        dataService={this.dataService}
                                        history={this.props.history}
                                        pageSize={this.state.pageSize}
                                        pageNumber={this.state.pageNumber}
                                        rarityFilter={this.state.rarityFilter}
                                        textFilter={this.state.text}
                                        urlPreffix={this.props.urlPreffix}
                                        showTemplate={false}
                                    />
                                )}
                            </Col>
                        </Grid>
                    </Container>
                </NavNotifier>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state: IApplicationState, ownProps) {
    return {
        ...ownProps,
        ...state.routing,
    };
}

export default connect(mapStateToProps, { ...actions })(withRouter(ArtsPage));



// WEBPACK FOOTER //
// ./src/components/arts/arts.tsx